import { Injectable, OnDestroy } from '@angular/core';
import { Subject, BehaviorSubject, fromEvent } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { Router } from '@angular/router';
// Menu
export interface Menu {
  headTitle?: string;
  headTitle2?: string;
  path?: string;
  title?: string;
  icon?: string;
  iconType?: 'v2' | 'v3';
  type?: string;
  badgeValue?: string;
  badgeClass?: string;
  badgeText?: string;
  active?: boolean;
  selected?: boolean;
  bookmark?: boolean;
  children?: Menu[];
  children2?: Menu[];
  Menusub?: boolean;
  target?: boolean;
  menutype?:string,
  dirchange?:boolean,
  nochild?:any

}

@Injectable({
  providedIn: 'root',
})
export class NavService implements OnDestroy {
  private unsubscriber: Subject<any> = new Subject();
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(
    window.innerWidth
  );

  // Language
  public language = false;

  // Mega Menu
  public megaMenu = false;
  public levelMenu = false;
  public megaMenuColapse: boolean = window.innerWidth < 1199 ? true : false;

  // Collapse Sidebar
  public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

  // For Horizontal Layout Mobile
  public horizontal: boolean = window.innerWidth < 991 ? false : true;

  // Full screen
  public fullScreen = false;
  active: any;

  constructor(private router: Router) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, 'resize')
      .pipe(debounceTime(1000), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 991) {
          this.collapseSidebar = true;
          this.megaMenu = false;
          this.levelMenu = false;
        }
        if (evt.target.innerWidth < 1199) {
          this.megaMenuColapse = true;
        }
      });
    if (window.innerWidth < 991) {
      // Detect Route change sidebar close
      this.router.events.subscribe((event) => {
        this.collapseSidebar = true;
        this.megaMenu = false;
        this.levelMenu = false;
      });
    }
  }

  ngOnDestroy() {
    this.unsubscriber.next;
    this.unsubscriber.complete();
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  MENUITEMS: Menu[] = [
    // Dashboard
    { headTitle: 'MAIN' },
    {
      title: 'Dashboards',
      icon: 'home',
      iconType: 'v2',
      type: 'link',
      selected : true,
      active: true,
      dirchange: false,
      path:'dashboard'
    },
    {
      title: 'insights',
      icon: 'sparkles-alt',
      iconType: 'v3',
      type: 'link',
      selected : false,
      active: false,
      path:'/insights'
    },
    { headTitle: 'Analysis Hub' },
    {
      title: 'Conversation Intelligence',
      icon: 'pulse',
      iconType: 'v2',
      type: 'sub',
      active: false,
      children: [
          { path: '/analysis-hub/engagement-dynamics', title: 'Engagement Dynamics', type: 'link' },
          { path: '/analysis-hub/alignment-relationship', title: 'Alignment & Relationship', type: 'link' },
          { path: '/analysis-hub/breakdowns-risks', title: 'Breakdowns && Risks', type: 'link' },
      ]
    },
    { headTitle: 'Conversations' },
    {
      title: 'Analysis Workspace',
      icon: 'message-square-dots',
      iconType: 'v2',
      type: 'sub',
      active: false,
      children: [
        {
          path: '/conversations/upload-conversation',
          title: 'Analyze Your Meetings',
          type: 'link'
        },
        {
          path: '/conversations/all-analyses',
          title: 'All Your Meetings',
          type: 'link'
        }
      ]
    },
    { headTitle: 'Platform' },
    {
      title: 'Billing',
      icon: 'credit-card',
      iconType: 'v2',
      type: 'link',
      selected : false,
      active: false,
      path:'/billing'
    },
    {
      title: 'About FusionLex',
      icon: 'shield-quarter',
      iconType: 'v2',
      type: 'link',
      selected : false,
      active: false,
      path:'/about-fusionlex'
    },
  ];

  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
}
